import { Badge, useMantineTheme } from '@mantine/core';
import { useMemo } from 'react';
import { getContrastingTextColor } from '../../utils/color';

type StatusVariant = 'success' | 'info' | 'warning' | 'danger';

interface StatusPillProps {
  status: StatusVariant;
  children: React.ReactNode;
}

export default function StatusPill({ status, children }: StatusPillProps) {
  const theme = useMantineTheme();
  const gradient = theme.other.gradients[status];

  const gradientBg = `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`;
  const autoTextColor = useMemo(
    () => getContrastingTextColor(gradientBg),
    [gradientBg]
  );

  return (
    <Badge
      radius="xl"
      variant="filled"
      style={{
        backgroundImage: gradientBg,
        color: autoTextColor,
      }}
    >
      {children}
    </Badge>
  );
}
